(function () {
  if (window.__cardCarouselInitialized) return;
  window.__cardCarouselInitialized = true;

  function setActiveImage(carousel, index) {
    var images = carousel.querySelectorAll('.card-carousel__image');
    var dots = document.querySelectorAll(
      '.card-carousel-controls[data-carousel-target="' + carousel.id + '"] .card-carousel__dot'
    );
    if (!images.length) return;
    var newIndex = ((index % images.length) + images.length) % images.length;
    images.forEach(function (img, i) {
      img.classList.toggle('is-active', i === newIndex);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === newIndex);
    });
    carousel.dataset.activeIndex = newIndex;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.card-carousel__arrow');
    if (!arrow) return;
    event.preventDefault();
    event.stopPropagation();
    var controls = arrow.closest('.card-carousel-controls');
    if (!controls) return;
    var carousel = document.getElementById(controls.dataset.carouselTarget);
    if (!carousel) return;
    var current = parseInt(carousel.dataset.activeIndex || '0', 10);
    var direction = arrow.classList.contains('card-carousel__arrow--prev') ? -1 : 1;
    setActiveImage(carousel, current + direction);
  });

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.card-carousel__dot');
    if (!dot) return;
    event.preventDefault();
    event.stopPropagation();
    var controls = dot.closest('.card-carousel-controls');
    if (!controls) return;
    var carousel = document.getElementById(controls.dataset.carouselTarget);
    if (!carousel) return;
    setActiveImage(carousel, parseInt(dot.dataset.index, 10));
  });
})();